export default {
  id: {
    "ui:widget": "hidden",
  },
  notes: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },

  "ui:order": ["notes", "id"],
};
